import {Component} from '@angular/core';

@Component({
  selector: 'app-circle-money-icon',
  templateUrl: './circle-money-icon.component.html'
})
export class CircleMoneyIconComponent {
}
